// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__2oW47","contact":"footer_contact__yIhVd","buttons":"footer_buttons__1OO2c","bottom":"footer_bottom__2jKYa"};